/**
 * `/programmes/:programmeId/modules/:moduleId` — the module workspace's own
 * address, which is now a surface of the programme editor.
 *
 * @module router/module-workspace/ModuleWorkspaceRedirect
 */

import React from "react";

import { Navigate, useLocation, useParams } from "react-router";

import { DEFAULT_MODULE_TAB } from "@/router/programme-editor/studio/ModuleEditorRoute";

export function ModuleWorkspaceRedirect(): React.ReactElement | null {
  const { programmeId, moduleId } = useParams<{ programmeId: string; moduleId: string }>();
  // The legacy link's `?dev=true` is read off the address the editor renders at.
  const { search } = useLocation();
  if (!programmeId || !moduleId) {
    return null;
  }
  return (
    <Navigate
      to={`/programmes/${programmeId}/studio/${moduleId}/${DEFAULT_MODULE_TAB}${search}`}
      replace
    />
  );
}

export default ModuleWorkspaceRedirect;
